import { put, call, takeEvery } from "redux-saga/effects";
import FileSaver from "file-saver";

import Actions from "../Actions/Creators";
import Types from "../Actions/Types";
import Phi from "../Phi/Phi";
import Constants from "../Phi/Constants";
import { getLatestIdForProgram } from "../utils/helpers/commonHelper";

const addBillingDateToHistory = ({ program }, history = []) =>
  history.reduce((accumulatedHistory, historyItem) => {
    const currentProgram = program.filter(
      (p) => p.billing.id === historyItem.billing.id,
    )[0];
    let copyHistoryItem = { ...historyItem };
    copyHistoryItem.billing.inBillingStartDate =
      currentProgram && currentProgram.billing
        ? currentProgram.billing.billingStartDate
        : "";
    return Boolean(currentProgram)
      ? [...accumulatedHistory, copyHistoryItem]
      : [...accumulatedHistory];
  }, []);

function* getProgramByOrganization(action) {
  try {
    let config = { inOrganizationId: action.organization_id };

    const response = yield call(
      Phi.Organization.getProgramByOrganization,
      Phi.Organization,
      config,
    );
    const programList =
      response && response.programs && response.programs.length
        ? response.programs.filter(
            (program) =>
              program &&
              program.events &&
              program.events.length &&
              program.events.filter((pr) => pr.sub_program_id === 1)[0]
                .atleast_one_published,
          )
        : [];
    // const programList = [...response.programs]
    if (
      !!response.ok &&
      !!!response.error &&
      !!response.programs &&
      programList.length > 0
    ) {
      let currentProgram = programList[0];

      let programConfig = { id: programList[0].billing.id };
      let programDetails = yield call(
        Phi.Organization.getProgram,
        Phi.Organization,
        programConfig,
      );

      let history =
        programDetails &&
        programDetails.history &&
        programDetails.history.length > 0
          ? addBillingDateToHistory(
              { program: programList },
              programDetails.history,
            )
          : [];
      yield put(
        Actions.storeProgramList({
          programs: programList,
          startNodeMap: response.startNodeMap,
          currentProgram,
          history,
        }),
      );
      sessionStorage.setItem(
        "startNodemap",
        JSON.stringify(response.startNodeMap),
      );

      sessionStorage.setItem("currentProgam", JSON.stringify(currentProgram));
      const resultId = yield getLatestIdForProgram(response.startNodeMap, 6);
      sessionStorage.setItem("latestInfirmaryProgramId", resultId);
    } else {
      yield put(
        Actions.storeProgramList({
          programs: [],
          startNodeMap: {},
          currentProgram: {},
          history: [],
        }),
      );
    }

    const classes = yield call(
      Phi.Organization.getClasses,
      Phi.Organization,
      action.organization_id,
    );
    if (classes && !!!classes.error) {
      yield put(Actions.storeOrgClasses(classes));
    }
  } catch (error) {
    console.error("error fetching student list", error);
  }
}

function* getReport(action) {
  const { reportType, config } = action;
  const reportResponse = yield call(
    Phi.Organization.getReport,
    Phi.Organization,
    config.type === "pdf" ? reportType + "/pdf" : reportType,
    config,
  );

  if (reportResponse && !!!reportResponse.error) {
    console.log("file saver");
    if (config.type === "pdf") {
      FileSaver.saveAs(reportResponse.data, `${reportType}.pdf`);
    } else {
      yield put(
        Actions.loadReport(reportResponse.data || "<p>No Data to show</p>"),
      );
    }
  } else if (!!!reportResponse || reportResponse.error) {
    if (config.type === "html") {
      yield put(Actions.loadReport("<p>No Data to show</p>"));
    }
  }
  yield put(Actions.unsetLoader());
}

function* editOrganization(action) {
  const { organizationData, organizationId } = action;
  const config = {
    organizationData,
    organizationId,
  };
  const response = yield call(
    Phi.Organization.editOrganization,
    Phi.Organization,
    config,
  );
  yield getOrganization({ orgId: organizationId });
  return response;
}

function* uploadFile(action) {
  const { fileObj, contentId, category, fileGroup } = action;
  let docUploadSuccess,
    currentContentID = contentId;
  yield put(Actions.setLoader());
  //getting S3 credentials from S3 server
  const s3Credentials = yield call(
    Phi.Organization.getS3Credentials,
    Phi.Organization,
  );
  //console.log('Files to be uploaded + schoolContentId:::::', fileObj, currentContentID)

  //if we alreday have contentId for school/program
  // if (currentContentID && s3Credentials) {

  //   //iterating over the file object
  //   for (let i = 0; i < fileObj.length; i++) {

  //     let file = fileObj[i]
  //     //uploading file to S3 server
  //     let response = yield call(Phi.Organization.uploadToS3, file, s3Credentials, currentContentID)

  //     if (response && response.headers && response.headers.location) {
  //       console.log("file uploaded to S3:::::", file)

  //       let docUrl = response.headers.location
  //       let docContentIDPayload = {
  //         contentJson: JSON.stringify({
  //           content_url: docUrl.toString(),
  //           type: category.toString(),
  //           size: file.size,
  //           file_name: file.name.toString(),
  //           mimeType: file.type
  //         }),
  //         userid: 1,
  //         prefix: "HSG",
  //         uuidFlag: "true"
  //       }

  //       //create contentId for the file uploaded
  //       let docContentID = yield call(Phi.Organization.addContentNode, Phi.Organization, docContentIDPayload)

  //       if (docContentID && docContentID.length) {
  //         console.log("contentId created for uploaded file", docContentID)

  //         let payload = {
  //           source_node_id: currentContentID.toString(),
  //           target_node_id: docContentID[0].uuid.toString(),
  //           relation_type_id: 6
  //         }
  //         //association of doc uploaded to the school
  //         docUploadSuccess = yield call(Phi.Organization.addContentAssociation, Phi.Organization, { inAssociationJson: JSON.stringify([payload]) })
  //         console.log("association::::::::::", docUploadSuccess)

  //       } else {
  //         console.log("file contentId creation FAILED:::::", docContentID)
  //       }

  //     } else {
  //       console.log("file FAILED to upload to S3:::::", file)
  //     }

  //     docUploadSuccess && docUploadSuccess.status === 200 ? console.log("FULL upload Done") : console.log("FULL upload FAILED")
  //     console.log("association::::::::::", docUploadSuccess)
  //   }

  // }

  if (currentContentID && currentContentID !== undefined && s3Credentials) {
    //iterating over the file object
    for (let i = 0; i < fileObj.length; i++) {
      let file = fileObj[i];
      //uploading file to S3 server
      let response = yield call(
        Phi.Organization.uploadToS3,
        file,
        s3Credentials,
        currentContentID,
      );

      if (response && response.headers && response.headers.location) {
        console.log("file uploaded to S3:::::", file);

        let docUrl = response.headers.location;
        let docContentIDPayload = {
          contentJson: JSON.stringify({
            content_url: docUrl.toString(),
            type: category.toString(),
            size: file.size,
            file_name: file.name.toString(),
            mimeType: file.type,
          }),
          userid: 1,
          prefix: "HSG",
          uuidFlag: "true",
        };

        //create contentId for the file uploaded
        let docContentID = yield call(
          Phi.Organization.addContentNode,
          Phi.Organization,
          docContentIDPayload,
        );

        if (docContentID && docContentID.length) {
          console.log("contentId created for uploaded file", docContentID);

          let payload = {
            source_node_id: currentContentID.toString(),
            target_node_id: docContentID[0].uuid.toString(),
            relation_type_id: 6,
          };
          //association of doc uploaded to the school
          docUploadSuccess = yield call(
            Phi.Organization.addContentAssociation,
            Phi.Organization,
            { inAssociationJson: JSON.stringify([payload]) },
          );
          console.log("association::::::::::", docUploadSuccess);
        } else {
          console.log("file contentId creation FAILED:::::", docContentID);
        }
      } else {
        console.log("file FAILED to upload to S3:::::", file);
      }

      docUploadSuccess && docUploadSuccess.status === 200
        ? console.log("FULL upload Done")
        : console.log("FULL upload FAILED");
      //console.log("association::::::::::", docUploadSuccess)
    }
  } else if (s3Credentials) {
    //if we don't have contentId for school/program
    let parentContentIDPayload = {
      contentJson: JSON.stringify({
        content_url: "",
        type: "main",
      }),
      userid: 1,
      prefix: "HSG",
      uuidFlag: "true",
    };

    //contentId for the school
    let parentContentIDResponse = yield call(
      Phi.Organization.addContentNode,
      Phi.Organization,
      parentContentIDPayload,
    );

    if (parentContentIDResponse && parentContentIDResponse.length) {
      console.log(
        "ContentId for school created::::::::",
        parentContentIDResponse,
      );

      currentContentID = parentContentIDResponse[0].uuid;
      //setting up the contentId of school/program in store
      yield put(Actions.addContentID(currentContentID, fileGroup));

      //iterating over file Obj
      for (let i = 0; i < fileObj.length; i++) {
        let file = fileObj[i];
        //uploading file to S3
        let response = yield call(
          Phi.Organization.uploadToS3,
          file,
          s3Credentials,
          currentContentID,
        );

        if (response && response.headers && response.headers.location) {
          console.log("file uploaded to S3:::::", file);

          let docUrl = response.headers.location;
          let docContentIDPayload = {
            contentJson: JSON.stringify({
              content_url: docUrl.toString(),
              type: category.toString(),
              size: file.size,
              file_name: file.name.toString(),
              mimeType: file.type,
            }),
            userid: 1,
            prefix: "HSG",
            uuidFlag: "true",
          };

          //creating contentId for the uploaded doc
          let docContentID = yield call(
            Phi.Organization.addContentNode,
            Phi.Organization,
            docContentIDPayload,
          );

          if (docContentID && docContentID.length) {
            console.log(
              "contentId created for uploaded file::::",
              docContentID,
            );

            let payload = {
              source_node_id: parentContentIDResponse[0].uuid.toString(),
              target_node_id: docContentID[0].uuid.toString(),
              relation_type_id: 6,
            };

            //associating uploaded file to school
            docUploadSuccess = yield call(
              Phi.Organization.addContentAssociation,
              Phi.Organization,
              { inAssociationJson: JSON.stringify([payload]) },
            );
          } else {
            console.log("contentId creation FAILED:::::", docContentID);
          }
        } else {
          console.log("file FAILED to upload to S3:::::", file);
        }

        docUploadSuccess && docUploadSuccess.status === 200
          ? console.log("FULL upload Done")
          : console.log("FULL upload FAILED");
        console.log("association::::::::::", docUploadSuccess);
      }
    }
  }

  let contentIdObj = {
    contentId: currentContentID,
    fileGroup: fileGroup,
  };
  yield put(Actions.unsetLoader());

  //fetching all doc after uploading
  yield* fetchAllDocs(contentIdObj);
}

//to fetch all the doc for a contentId(school)
function* fetchAllDocs(action) {
  const { contentId, fileGroup } = action;
  yield put(Actions.setLoader());
  const payload = {
    sourceNodeUUID: contentId,
    targetNodeUUID: null,
    relationType: null,
  };

  const response = yield call(
    Phi.Organization.getContentAssociation,
    Phi.Organization,
    payload,
  );

  //update the store with the latest doc
  if (!(response && response.error)) {
    yield put(Actions.updateDocs(response, fileGroup));
  }
  yield put(Actions.unsetLoader());
}

//remove a doc from a contentId(school)
function* removeDoc(action) {
  let { targetID, fileGroup, category, srcID } = action;

  const payload = {
    id: action.id,
    source_node_id: srcID.toString(),
    target_node_id: targetID.toString(),
    relation_type_id: null,
    association_active: 3,
  };

  const response = yield call(
    Phi.Organization.editContentAssociation,
    Phi.Organization,
    { inAssociationJson: JSON.stringify([payload]) },
  );

  let currentContentID = {
    contentId: srcID,
    fileGroup: fileGroup,
  };
  //update the store with latest doc in the server
  yield* fetchAllDocs(currentContentID);
}

function* getGlossary() {
  let response = [];
  try {
    response = yield call(Phi.Organization.getGlossary, Phi.Organization);
    if (Boolean(response)) {
      yield put(Actions.storeGlossary(response));
    }
  } catch (error) {
    yield put(Actions.storeGlossary(response, error));
  }
}

function* getOrganization(action) {
  yield put(Actions.setLoader(`Fetching school details.`));
  try {
    const organization = yield call(
      Phi.Organization.getOrganization,
      Phi.Organization,
      action.orgId,
    );

    const countryResponse = yield call(
      Phi.Organization.getMetaData,
      Phi.Organization,
      { metaType: "country" },
    );
    const country =
      (countryResponse && countryResponse.length && countryResponse[0]) || {};

    const stateResponse = yield call(
      Phi.Organization.getMetaData,
      Phi.Organization,
      {
        metaType: "state",
        config: {
          countryId:
            country.id || Constants.defaultRegionCodes.INDIA_COUNTRY_CODE,
        },
      },
    );
    const state =
      (stateResponse &&
        stateResponse.length &&
        stateResponse.filter(
          (state) => state.id === organization.inOrganizationState,
        )[0]) ||
      {};

    const cityResponse = yield call(
      Phi.Organization.getMetaData,
      Phi.Organization,
      { metaType: "city", config: { stateId: state.id } },
    );
    const city =
      (cityResponse &&
        cityResponse.length &&
        cityResponse.filter(
          (city) => city.id === organization.inOrganizationDistrict,
        )[0]) ||
      {};

    yield put(
      Actions.storeOrganization({
        ...organization,
        countryName: country.country_name,
        stateName: state.state_desc,
        cityName: city.city_name,
      }),
    );
  } catch (error) {
    console.error(error);
  }
  yield put(Actions.unsetLoader());
}

function* fetchOverViewReport(action) {
  const { startNode } = action;

  let overViewReport,
    healthResponse,
    growthResponse,
    genderResponse,
    classResponse,
    hygieneResponse;

  try {
    const startNodeId = startNode;

    healthResponse = yield call(
      Phi.Organization.getHealthOverviewReport,
      Phi.Organization,
      { startNodeId },
    );

    growthResponse = yield call(
      Phi.Organization.getGrowthOverviewReport,
      Phi.Organization,
      { startNodeId },
    );

    // genderResponse = yield call(Phi.Organization.getGenderOverviewReport, Phi.Organization, {startNodeId})

    classResponse = yield call(
      Phi.Organization.getClassOverviewReport,
      Phi.Organization,
      { startNodeId },
    );

    // hygieneResponse = yield call(Phi.Organization.getHygieneOverviewReport, Phi.Organization, {startNodeId})

    yield put(
      Actions.storeOverViewReport({
        health:
          healthResponse && healthResponse.length ? healthResponse[0] : null,
        growth:
          growthResponse && growthResponse.length ? growthResponse[0] : null,
        // gender: genderResponse && genderResponse.length ? JSON.parse(genderResponse[0].gender_overview) : null,
        class: classResponse && classResponse.length ? classResponse[0] : null,
        // hygiene: hygieneResponse && hygieneResponse.length ? hygieneResponse[0] : null
      }),
    );
  } catch (error) {
    console.error(error);
  }

  yield put(Actions.unsetLoader());
}

function* getDMFTIndex(action) {
  const { startNodeId, studentId } = action;

  const response = yield call(
    Phi.Organization.fetchDMFTIndex,
    Phi.Organization,
    action,
  );

  if (!Boolean(response.error)) {
    yield put(Actions.updateDMFTIndex(response));
  } else {
    yield put(Actions.updateDMFTIndex({ error: response }));
  }
}

function* getSchoolClasses(action) {
  const classes = yield call(
    Phi.Organization.getClasses,
    Phi.Organization,
    action.organization_id,
  );

  if (classes && !!!classes.error) {
    yield put(Actions.storeOrgClasses(classes));
  }
}

function* getStudentBoardingType(action) {
  const boardingTypes = yield call(
    Phi.Organization.getStudentBoardingType,
    Phi.Organization,
    action.organizationId,
  );

  if (boardingTypes && boardingTypes.length) {
    yield put(Actions.storeStudentBoardingType(boardingTypes));
  }
}

// new saga function added for organization overview//

function* getOrganizationOverview(action) {
  try {
    let token = yield call(Phi.phiRef.getSession);
    if (Boolean(token) && Boolean(token.jwt)) {
      let response = yield call(Api.getOrganizationOverview, action.param);
      if (
        response.ok &&
        response.data &&
        response.data.results &&
        response.data.results.length > 0
      ) {
        return response.data.results;
      } else {
        return { error: response.problem };
      }
    }
    return null;
  } catch (error) {
    console.error("Error fetching organization overview:", error);
    return { error: error.message };
  }
}

// Saga Watcher
export function* watchOrganizationActions() {
  yield* [
    takeEvery(Types.GET_PROGRAM_BY_ORGANIZATION, getProgramByOrganization),
    takeEvery(Types.GET_REPORT, getReport),
    takeEvery(Types.PUT_ORGANIZATION, editOrganization),
    takeEvery(Types.UPLOAD_FILE, uploadFile),
    takeEvery(Types.FETCH_ALL_DOCS, fetchAllDocs),
    takeEvery(Types.REMOVE_DOC, removeDoc),
    takeEvery(Types.GET_GLOSSARY, getGlossary),
    takeEvery(Types.GET_ORGANIZATION, getOrganization),
    takeEvery(Types.FETCH_OVERVIEW_REPORT, fetchOverViewReport),
    takeEvery(Types.GET_DMFT_INDEX, getDMFTIndex),
    takeEvery(Types.GET_SCHOOL_CLASSES, getSchoolClasses),
    takeEvery(Types.GET_STUDENT_BOARDING_TYPE, getStudentBoardingType),

    // takeEvery(Types.GET_ORGANIZATION_OVERVIEW, getOrganizationOverview),
  ];
}
